import { Doms } from "../../../components/doms";
import { ModalController } from "../../../components/modal/controller";

export class UserPrivateAccountModel {
  static instance;

  constructor() {
    if (UserPrivateAccountModel.instance) {
      throw new Error('Clase singleton')
    }
    this.doms = new Doms();
  }

  static getInstance() {
    if (!UserPrivateAccountModel.instance) {
      UserPrivateAccountModel.instance = new UserPrivateAccountModel();
    }
    return UserPrivateAccountModel.instance;
  }

  validate(_data) {
    let errors = [];
    if (this.doms.getDom('account-permalink-status').innerText.indexOf('Enlace') == -1) {
      return false;
    }
    if (this.doms.getDom('account-permalink-status').innerText.indexOf('no disponible') > -1) {
      errors.push({ id: 'permalink', message: 'Debe ingresar un enlace permanente que esté disponible.' });
      // new ModalController('Enlace permanente', 'Debe ingresar un enlace permanente que esté disponible.').show();
    }
    if (!_data.email) {
      errors.push({ id: 'email', message: 'El email no puede estar vacío.' });
    } else if (_data.email.indexOf('@') == -1) {
      errors.push({ id: 'email', message: 'El email no es válido.' });
    } else {
      let parts = _data.email.split('@');
      if (parts.length < 2) {
        errors.push({ id: 'email', message: 'El email no es válido.' });
      } else {
        let parts2 = parts[1].split('.');
        if (parts2.length < 2) {
          errors.push({ id: 'email', message: 'El email no es válido.' });
        }
      }
    }

    // PASSWORD
    if (!_data.password) {
      errors.push({ id: 'password', message: 'La contraseña no puede estar vacía.' });
    } else if (_data.password.length < 6) {
      errors.push({ id: 'password', message: 'La contraseña debe tener al menos 6 caracteres.' });
    }

    if (errors.length > 0) {
      return errors;
    }
    return true;
  }

  async checkPermalink(_value) {
    try {
      let user = await app.userPrivateController.auth.model.getSessionData();
      return await APICRUD.Auth.UserPermalinkAvailable(_value, user.idcod);
    } catch (error) {
      console.error('checkPermalink: ', error);
      throw error;
    }
  }
}
